/* eslint-disable import/prefer-default-export */

export const PREVIEW = 'PREVIEW';
export const SEND = 'SEND';

export const UPDATE_UI_STATE = 'UPDATE_UI_STATE';
export const OFFER_TO_CHANGED = 'OFFER_TO_CHANGED';
export const OFFER_BODY_CHANGED = 'OFFER_BODY_CHANGED';
